import { withNavigationWatcher } from './contexts/navigation';

import {
  AllOrders,
  ASZFPage,
  AutoLogoutPage,
  CategoriesPage,
  CheckoutForm,
  FreeContent,
  GDPRPage,
  HomePage,
  IncomeStatPage,
  OrderForm,
  ProfilePage,
  SubscribeForm,
  Subscriptions,
  UsersPage,
  videoAssign,
  VideosPage,
  VideoStatPage,
} from './pages';

const routes = [
  {
    path: '/profile',
    element: ProfilePage,
  },
  {
    path: '/home',
    element: HomePage,
  },
  {
    path: '/videos',
    element: VideosPage,
  },

  {
    path: '/categories',
    element: CategoriesPage,
  } /*
  {
    path: '/book-order',
    element: BookOrderPage,
  },*/,

  {
    path: '/users',
    element: UsersPage,
  },
  {
    path: '/videoAssign',
    element: videoAssign,
  },
  {
    path: '/subscriptions',
    element: Subscriptions,
  },
  {
    path: '/order',
    element: OrderForm,
  },
  {
    path: '/checkout',
    element: CheckoutForm,
  },

  {
    path: '/allOrders',
    element: AllOrders,
  },
  {
    path: '/aszf',
    element: ASZFPage,
  },
  {
    path: '/gdpr',
    element: GDPRPage,
  },
  {
    path: '/incomeStat',
    element: IncomeStatPage,
  },
  {
    path: '/videoStat',
    element: VideoStatPage,
  },
  {
    path: '/freeVideos',
    element: FreeContent,
  },
  {
    path: '/logout',
    element: AutoLogoutPage,
  },
  {
    path: '/subscribe',
    element: SubscribeForm,
  },
];

export default routes.map((route) => {
  return {
    ...route,
    element: withNavigationWatcher(route.element, route.path),
  };
});
